import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 30, x = 0, className = "", ...rest }) {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: reduce ? 0 : y, x: reduce ? 0 : x }}
            whileInView={{ opacity: 1, y: 0, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay, ease: EASE }}
            {...rest}
        >
            {children}
        </motion.div>
    );
}

export function Eyebrow({ children, dark = false }) {
    return (
        <p
            className={`mono text-[11px] sm:text-xs font-medium uppercase tracking-[0.28em] ${
                dark ? "text-[var(--dark-accent)]" : "text-[var(--accent-hover)]"
            }`}
        >
            {children}
        </p>
    );
}
